// removed by extract-text-webpack-plugin
module.exports = {"cont":"_2_b9QIsHnp4KsXM-jbCeAp","counterFrame":"_33UfvYYyIvyQ8PQ7oiVHHc","spinner":"_1jK9U4QRGW9O6fKLa8Vt3t","spin":"_pm68n6bBA4kCLTM7XKpo","spinRed":"_1F_LSbdAQB_H0CDrG98gcl","spinYellow":"_3ee1Rz1RzAiYvJcwWP52B9","spinGreen":"_2fCiSfDIkQerf5krJQl_Bc","number":"_2vihWm5bflIl8U5217Y4C0","num":"_3Y3T4yk4tDu4zEkTBU7Hgz","numberTextBased":"_7mwvaTuIOPp3TQdAa1Dak"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/eventLiveCounter.css
// module id = 757
// module chunks = 0